export const colors = {
  branco: "#FCF6F4",
  preto: "#000000",
  purple: "#5b26ff",
  purpleWhite: "#a99ec9",
  blueOpacity: "#081413c7",
  greenOpacity: "#040e004d",
};
